"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dolcedo": {
    "aed30b87": [{
      "hkey": "e62a2b01",
      "slug": "dolcedo",
      "name": "Dolcedo",
      "primary": true,
      "skipSearch": false
    }],
    "castellazzo": [{
      "hkey": "e62a2b01",
      "slug": "dolcedo",
      "name": "Dolcedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9107281": [{
      "hkey": "e62a2b01",
      "slug": "dolcedo",
      "name": "Dolcedo",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "e62a2b01",
      "slug": "dolcedo",
      "name": "Dolcedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18c6e243": [{
      "hkey": "e62a2b01",
      "slug": "dolcedo",
      "name": "Dolcedo",
      "primary": true,
      "skipSearch": false
    }],
    "ripalta": [{
      "hkey": "e62a2b01",
      "slug": "dolcedo",
      "name": "Dolcedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;